import { Directive, Input, ViewContainerRef, OnInit, ComponentFactoryResolver } from '@angular/core';
import { Subject } from 'rxjs';
import { Workflow, WorkflowStep, WorkflowStepRule, WorkflowStepRuleAction } from 'src/app/modules/core/store/models/workflow.model';
import { WorkflowRuleActionEdit } from './workflow-rule-action-edit-implemention';
import { WorkflowRuleActionsMap } from './workflow-rule-actions.map';
import { WorkflowRuleDataField } from '../../../store/workflow/workflow.models';

@Directive({
    selector: '[workflow-rule-action-edit]',
    standalone: false
})
export class WorkflowRuleActionEditDirective implements OnInit {
  _action: WorkflowStepRuleAction;
  _implementationUId: string;

  @Input() schema: WorkflowRuleDataField[];
  @Input() workflow: Workflow;
  @Input() step: WorkflowStep;
  @Input() rule: WorkflowStepRule;
  @Input() readOnly: boolean;

  @Input() set action(value: WorkflowStepRuleAction) {
    this._action = value;
  }

  @Input() set implementationUId(value: string) {
    this._implementationUId = value;
    this.loadComponent();
  }

  editInstance: WorkflowRuleActionEdit;

  destroy$ = new Subject<void>();

  constructor(
    private view: ViewContainerRef,
    private resolver: ComponentFactoryResolver,
  ) { }

  ngOnInit() {
  }

  private loadComponent() {

    this.view.clear();

    const componentType = WorkflowRuleActionsMap.get(this._implementationUId);
    if (!componentType) {
      return;
    }

    const factory = this.resolver.resolveComponentFactory(componentType.component);

    const component: any = this.view.createComponent(factory);
    this.editInstance = component.instance as WorkflowRuleActionEdit;

    this.editInstance.schema = this.schema;
    this.editInstance.workflow = this.workflow;
    this.editInstance.step = this.step;
    this.editInstance.rule = this.rule;
    this.editInstance.action = this._action;
    this.editInstance.implementationUId = this._implementationUId;
    this.editInstance.readOnly = this.readOnly;

    this.editInstance.load();
  }

  load(): void {
    if (this.editInstance) {
      this.editInstance.load();
    }
  }

  save(): boolean {
    if (this.editInstance) {
      return this.editInstance.save();
    }
    else {
      return true;
    }
  }
}
